module.exports = __webpack_public_path__ + "img/xuanzhong.d5fc4179.svg";